"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var styles_1 = require("@mui/material/styles");
var Button = __importStar(require("./A_Button"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
/** Instance of an Action Card for the Moda Build Your Sofa action */
var Component = function (p) {
    var _a, _b, _c, _d;
    var theme = (0, styles_1.useTheme)();
    return (Preact.h(Box_1.default, { sx: __assign({ backgroundColor: (_c = (_b = (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.secondary) === null || _b === void 0 ? void 0 : _b.main) !== null && _c !== void 0 ? _c : 'secondary.main', color: 'white', display: 'flex', borderRadius: '8px', overflow: 'hidden', height: 'max-content' }, p.sx) },
        Preact.h(Box_1.default, { sx: {
                flexGrow: 1,
                padding: '18px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            } },
            Preact.h(Typography_1.default, { sx: { marginBottom: '8px' }, variant: "h5" }, "Build your sofa"),
            Preact.h(Typography_1.default, { variant: "body2", sx: { width: '80%' } }, "Create the perfect sofa for your garden."),
            Preact.h(Button.Component, { onClick: p.onGetStartedClick, loading: (_d = p.loading) !== null && _d !== void 0 ? _d : false, variant: "contained", size: "small", sx: {
                    width: 'max-content',
                    padding: '8px',
                    marginTop: '12px',
                    borderRadius: '8px',
                } }, "Get started")),
        Preact.h("img", { style: { width: '45%', maxHeight: '260px', objectFit: 'cover' }, src: p.imageUrl })));
};
exports.Component = Component;
